import { Link } from 'react-router-dom';
import { SITE_GLASS_CARD } from '../../constants/siteUi';

export type ToolCardDef = {
  slug: string;
  title: string;
  description: string;
  /** If set, navigate here instead of /dashboard/tools/:slug */
  href?: string;
};

export const INVESTOR_TOOLS: ToolCardDef[] = [
  {
    slug: 'cash-flow',
    title: 'Cash flow calculator',
    description: 'Monthly cash flow from rent, operating expenses, and debt service.',
  },
  {
    slug: 'cap-rate',
    title: 'Cap rate calculator',
    description: 'Capitalization rate from NOI and property value.',
  },
  {
    slug: 'rental-income',
    title: 'Rental income estimator',
    description: 'Estimate effective monthly rent from square footage and market rates.',
  },
  {
    slug: 'mortgage',
    title: 'Mortgage calculator',
    description: 'Monthly payment from loan amount, rate, and term.',
  },
  {
    slug: 'value-add',
    title: 'Value-add calculator',
    description: 'Property value lift from rent improvements at a cap rate.',
  },
  {
    slug: 'roi-coc',
    title: 'ROI & cash-on-cash',
    description: 'Return on investment and cash-on-cash return.',
  },
  {
    slug: 'underwriting',
    title: 'Underwriting calculator',
    description: 'NOI-based offer price from income, expenses, and target cap.',
  },
  {
    slug: 'quick-deal',
    title: 'Quick deal analyzer',
    description: 'Back-of-napkin cash flow, cap rate, and cash-on-cash.',
  },
  {
    slug: 'ai-analyzer',
    title: 'Comprehensive deal analyzer',
    description: 'AI-powered extraction from documents and full underwriting dashboard.',
    href: '/dashboard/analyzer',
  },
];

export function InvestorToolsLibrary() {
  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <p className="font-display text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-[var(--home-miami-blue)]">
          Investor portal
        </p>
        <h1 className="font-display text-2xl font-bold tracking-tight text-[var(--home-text-on-dark)] md:text-3xl">
          Tools library
        </h1>
        <p className="max-w-2xl font-body text-sm leading-relaxed text-[var(--home-muted-on-dark)]">
          Calculators and analyzers for multifamily and small-bay underwriting. Choose a tool to open it.
        </p>
      </header>

      <ul className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {INVESTOR_TOOLS.map((t) => {
          const to = t.href ?? `/dashboard/tools/${t.slug}`;
          return (
            <li key={t.slug}>
              <Link
                to={to}
                className={`${SITE_GLASS_CARD} block h-full p-5 transition hover:border-[var(--home-miami-blue)]/35 hover:bg-white/[0.03]`}
              >
                <h2 className="font-display text-base font-bold text-[var(--home-text-on-dark)]">{t.title}</h2>
                <p className="mt-2 font-body text-sm leading-relaxed text-[var(--home-muted-on-dark)]">{t.description}</p>
                <span className="mt-4 inline-block font-body text-xs font-semibold text-[var(--home-miami-blue)]">
                  Open →
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
